import LuxuryEscapesSmallLogo from 'components/App/Header/Logo/logos/LuxuryEscapesSmallLogo'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  height: ${rem(24)};
  width: ${rem(34)};
  border-radius: ${props => props.theme.borderRadius.M};
  display: grid;
  place-items: center;
  flex-shrink: 0;

  &.tier-bronze {
    background: ${props => props.theme.palette.product.loyalty.bronze.gradientPrimaryBackground};
    color: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
  }

  &.tier-silver {
    background: ${props => props.theme.palette.product.loyalty.silver.gradientPrimaryBackground};
    color: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
  }

  &.tier-gold {
    background: ${props => props.theme.palette.product.loyalty.gold.gradientPrimaryBackground};
    color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
  }

  &.tier-platinum {
    background: ${props => props.theme.palette.product.loyalty.platinum.gradientPrimaryBackground};
    color: ${props => props.theme.palette.product.loyalty.platinum.normalContrast};
  }
`

const Logo = styled(LuxuryEscapesSmallLogo)`
  path {
    fill: currentColor;
  }
`

interface Props {
  tier: App.LoyaltyTier
}

function LoyaltyCardCompact({ tier }: Props) {
  return <Container className={`tier-${tier}`}>
    <Logo height={rem(12)} />
  </Container>
}

export default LoyaltyCardCompact
